import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@pishgamrayan/ng-form-kit';

import { TranslationModule } from 'src/app/i18n';
import { PagesSharedModule } from 'src/app/pages/shared/pages-shared.module';
import { EnumSelectSearchComponent } from 'src/app/shared/components/select-search/enum-select-search.component';
import { FormBtnsModule } from 'src/app/shared/global/form-btns/form-btns.module';
import { ShareModule } from 'src/app/shared/share.module';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule,
    ReactiveFormsModule,
    PagesSharedModule,
    FormsModule,
    FormFieldComponent,
    FormBtnsModule,
    EnumSelectSearchComponent,
    ShareModule,
  ],
  exports: [
    CommonModule,
    TranslationModule,
    PagesSharedModule,
    ReactiveFormsModule,
    FormsModule,
    FormFieldComponent,
    FormBtnsModule,
    EnumSelectSearchComponent,
    ShareModule,
  ],
})
export class BaseFormModule {}
